import {stringifyQuery} from "vue-router";

export default function generateLink(route, page) {
  const params = new URLSearchParams(stringifyQuery(route.query));
  params.set('page', page.toString());

  const baseUrl = `${route.path}?${params.toString()}`;

  if ('' === route.hash) {
    return baseUrl;
  }

  return `${baseUrl}${route.hash}`;
}